import { LoadingRing } from '@pms-digital/design-system';
import { NOYAUX, type NoyauCode } from '@rosetta/shared';

/**
 * The accessible name of a noyau being translated (#36): "SPG, en cours de traduction". The link
 * that carries it opens the waiting screen of the launch that translates it.
 */
export const nomNoyauEnCours = (code: NoyauCode): string => `${code}, en cours de traduction`;

/** The tooltip of that link: the code with its long name, then the state. */
export const infobulleNoyauEnCours = (code: NoyauCode): string =>
  `${code} ${NOYAUX[code].famille} ${NOYAUX[code].variante}, en cours de traduction`;

/**
 * The turning ring of a noyau being translated (#36), the `LoadingRing` of the design system in
 * `bleu-nuit` on the white of the page (size "xs", 10 px, 2 px stroke), 3:1 at
 * least (S14). Decorative: the name of the link says "en cours de traduction". It never turns for
 * someone who asked for less motion (`.animate-spin` in `styles.css`): the ring is then still, and
 * the state is in the name and the tooltip.
 */
export function RondChargement() {
  return (
    <span className="inline-flex shrink-0 text-bleu-nuit">
      <LoadingRing size="xs" />
    </span>
  );
}
